import React from 'react';
import Button from 'react-bootstrap/lib/Button';
import ListGroup from 'react-bootstrap/lib/ListGroup';
import ListGroupItem from 'react-bootstrap/lib/ListGroupItem';
// import { MultiSelect } from 'react-selectize';

const AddSelfCredits = ({
  handleRequestCredits,
  handleRoleSelected,
  handelSkip,
  loadingRoles = true,
  roles = [],
  selectedRoles = [],
  title = 'What was your role on this project?',
}) => {
  return (
    <div>
      <ListGroup>
        <ListGroupItem>
          <strong>{title}</strong>
        </ListGroupItem>
        <ListGroupItem className="cf">
          {/* <MultiSelect
            hideResetButton
            options={roles.map((roleOption) => {
              return { label: roleOption.name, value: roleOption.name };
            })}
            values={selectedRoles}
            className="mb"
            style={{ width: '100%' }}
            placeholder="Select roles..."
            renderNoResultsFound={() => {
              return (
                <div className="no-results-found">
                  {loadingRoles ? 'loading roles...' : 'No roles found'}
                </div>
              );
            }}
            onValuesChange={handleRoleSelected} /> */}

          <Button bsStyle="info" className="hidden-xs" onClick={handelSkip}>
            I didn't work on this project
          </Button>
          <Button
            bsStyle="success"
            className="right hidden-xs"
            disabled={selectedRoles.length <= 0}
            onClick={handleRequestCredits}
          >
            Request my credit
          </Button>

          <Button
            bsStyle="success"
            className="hidden-sm hidden-md hidden-lg"
            block
            disabled={selectedRoles.length <= 0}
            onClick={handleRequestCredits}
          >
            Request my credit
          </Button>
          <Button
            bsStyle="info"
            className="hidden-sm hidden-md hidden-lg"
            block
            onClick={handelSkip}
          >
            I didn't work on this project
          </Button>
        </ListGroupItem>
      </ListGroup>
    </div>
  );
};

export default AddSelfCredits;
